import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BookingModule } from '@fry/booking/app';
import { FryCommonModule } from '@fry/components/common';
import { MaterialModule } from '@fry/components/material';
import { UnboxedModule } from '@fry/ui';
import { WalkthroughsModule } from '@fry/walkthroughs/walkthroughs.module';
import { InteractiveTableModule } from '@fry/components/common/list/interactive-table/interactive-table.module';

import { UsersCardsModule } from './cards';
import { UsersRoutingModule } from './users-routing.module';
import { UserAddComponent } from './user-add/user-add.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserEditBasicComponent } from './user-edit/user-edit-basic/user-edit-basic.component';
import { UserEditDetailsComponent } from './user-edit/user-edit-details/user-edit-details.component';
import { UserEditEmailsComponent } from './user-edit/user-edit-emails/user-edit-emails.component';
import { UserEditRolesComponent } from './user-edit/user-edit-roles/user-edit-roles.component';
import { UserLanguageComponent } from './user-language/user-language.component';
import { UserLanguageService } from './user-language/user-language.service';
import { UserLanguageEditComponent } from './user-language-edit/user-language-edit.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserCredentialComponent } from './user-login/user-credential.component';
import { UserLoginComponent } from './user-login/user-login.component';
import { UserViewComponent } from './user-view/user-view.component';
import { UsersComponent } from './users/users.component';
import { BoardComponent } from '@fry/boards/components';
import { EasFormModule } from '../common/easform/easform.module';
import { UserEmailsComponent } from "@fry/components/users/user-emails/user-emails.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    MaterialModule,
    UsersRoutingModule,
    UnboxedModule,
    UsersCardsModule,
    WalkthroughsModule,
    BookingModule,
    BoardComponent,
    EasFormModule,
    InteractiveTableModule,
  ],
  declarations: [
    UsersComponent,
    UserListComponent,
    UserEditComponent,
    UserEditBasicComponent,
    UserEditEmailsComponent,
    UserEditDetailsComponent,
    UserEditRolesComponent,
    UserViewComponent,
    UserAddComponent,
    UserDashboardComponent,
    UserEmailsComponent,
    UserLoginComponent,
    UserLanguageComponent,
    UserLanguageEditComponent,
    UserCredentialComponent,
  ],
  exports: [
  ],
  providers: [
    UserLanguageService
  ],
})
export class UsersModule {}
